import React from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useState, useEffect } from 'react';
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import axios from 'axios';
import { Alert } from 'react-bootstrap';

function Deptposting() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const navigate = useNavigate();
    const Swal = require('sweetalert2')

    const [dept_name, setddept_name] = useState("");
    const [dept_code, setdept_code] = useState("");
    const [dept_headname, setdept_headname] = useState("");
    const [dept_description, setdept_description] = useState("");

    // add department
    const handleSubmit = (event) => { 
            event.preventDefault();     
            const data = {
                dept_name: dept_name,
                dept_code: dept_code,
                dept_headname: dept_headname,
                dept_description: dept_description,
                dept_createdby: accessuserid,   
            };
            fetch(baseurladdress + "adddepartment", {
                method: "POST",
                headers: {
                    Accept: "application/form-data",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify(data),
            })
                .then((res) => res.json())
                .then((result) => {
                    if (result["status"] === "success") {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 500,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
    
                        Toast.fire({
                            icon: 'success',
                            title: 'Added Successfully'
                        })
                        navigate("/departmentlist");
    
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })
    
                        Toast.fire({
                            icon: 'error',
                            title: 'Something went wrong'
                        })
                    }
    
                });
        };
        
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div class="content-wrap">
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/departmentlist"}>
                        <div style={{ display: "flex" }}>
                            <a class="float ">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>
                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div class="col-xl-12 col-xxl-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">ADD DEPARTMENT DETAILS</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="basic-form">

                                            <div class="form-row">
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6><span style={{"color":"red"}}>*</span>Department Name</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        placeholder='Department Name'
                                                        required
                                                        onChange={(e) => setddept_name(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6><span style={{"color":"red"}}>*</span>Department Code</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        placeholder='Department Code'
                                                        required
                                                        onChange={(e) => setdept_code(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6><span style={{"color":"red"}}>*</span>Department Head Name</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        placeholder='Department Head Name'
                                                        required
                                                        onChange={(e) => setdept_headname(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-12 mt-2 mt-sm-0">
                                                    <h6>Description</h6>
                                                    <textarea class="form-control" style={{ height: "10em" }}
                                                        placeholder='About Department'
                                                        onChange={(e) => setdept_description(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-12 offset-6">
                                        <button type="submit" class="btn btn-primary mb-2" >Submit</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Deptposting;